<template>
  <div
    class="absolute right-[1px] bottom-1 size-[10px] rounded-full border-2 border-white bg-primary dark:border-dark-primary"
  />
</template>
